import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormModel} from '../../../models';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

@Component({
  selector: 'app-dm-email-generic',
  templateUrl: './email-generic.component.html',
  styleUrls: ['./email-generic.component.scss']
})
export class EmailGenericComponent implements OnInit {
  @Input() form: FormModel;
  @Output() emailEvent: EventEmitter<string> = new EventEmitter<string>();
  formGroup: UntypedFormGroup;
  DOMAIN_PARIS8 = 'univ-paris8.fr';
  get email_generic() {
    return this.formGroup?.get('email_generic');
  }
  constructor() { }

  ngOnInit(): void {
    this._setForm();
  }
  private _validatorDomainParis8(regexp: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isDomainP8 = regexp.test(control.value);
      if (control.value && ! isDomainP8) {
        return  {email: {value: control.value}};
      }
      return Validators.email;
    };
  }
  _getRegexpEmail() {
    const domain = this.DOMAIN_PARIS8.replace('.', '\\.');
    return RegExp(`^.+${domain}$`, 'i');
  }
  _setForm() {
    const regexp = this._getRegexpEmail();
    this.formGroup = new UntypedFormGroup({
      'email_generic': new UntypedFormControl(
        this.form?.email_generic,
        [this._validatorDomainParis8(regexp)])
    });
    this.email_generic.valueChanges.subscribe(_email => {
      if (this._hasGoodEmailFormat()) {
        this.emailEvent.emit(_email);
      }
    });
  }
  _hasGoodEmailFormat() {
    return ! this.email_generic.errors?.email;
  }
  getEmailErrorMessage() {
    if (! this._hasGoodEmailFormat()) {
      return 'le courriel n\'est pas valide';
    }
    return '';
  }
  isEmailValid() {
    return this.formGroup.get('email_generic').valid;
  }
}
